import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';

import { ConstantsService } from 'app/services/constants-service';
import {environment} from "../../environments/environment";

/**
 * Cookie service for the application.
 *
 * <p> Wraps external cookie library.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
@Injectable()
export class CookieService {

    public get(name: string): string {
        return Cookie.get(name);
    }

    public set(name: string, value: string) {
      let pathValue = ConstantsService.COOKIE_PATH;
      let domain = undefined;
      if (name === ConstantsService.COOKIE_ACCESS_TOKEN) {
        pathValue = '/';
        domain = `${environment.production ? '.' : ''}${window.location.hostname}`;
      }
        Cookie.set(name, value, null, pathValue, domain);
    }

    public removeAll() {
        Cookie.deleteAll();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/cookie.service.ts